import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ViewComponent } from '../../../../core/components/view/view.component';
import { ViewOnlyType } from '../../../../core/models';

@Component({
  selector: 'app-quote-product-multi-select',
  templateUrl: './quote-product-multi-select.component.html',
  styleUrls: ['./quote-product-multi-select.component.scss'],
  imports: [CommonModule],
})
export class QuoteProductMultiselectComponent extends ViewComponent {
  @Input() override dataList: ViewOnlyType[] = [];
}
